module.exports = __webpack_public_path__ + "img/filtro.c1e51923.svg";